export function LightenDarkenColor(color, perc) {
  var i = parseInt,
    round = Math.round,
    [r, g, b, a] = color.split(','),
    isNeg = perc < 0,
    offset = isNeg ? 0 : 255 * perc,
    absPerc = isNeg ? 1 + perc : 1 - perc
  return (
    'rgb' +
    (a ? 'a(' : '(') +
    round(i(r[3] == 'a' ? r.slice(5) : r.slice(4)) * absPerc + offset) +
    ',' +
    round(i(g) * absPerc + offset) +
    ',' +
    round(i(b) * absPerc + offset) +
    (a ? ',' + a : ')')
  )
}

export function shiftHealthColor(noHealth, fullHealth, perc) {
  var toInt = parseInt,
    round = Math.round,
    absPerc = 1 - perc,
    [rMin, gMin, bMin, aMin] = noHealth.split(','),
    [rMax, gMax, bMax, aMax] = fullHealth.split(','),
    hasAlpha = aMin || aMax,
    alpha = hasAlpha
      ? ',' +
        (!aMin ? aMax : !aMax ? aMin : round((parseFloat(aMin) * absPerc + parseFloat(aMax) * perc) * 1000) / 1000) +
        ')'
      : ')'
  return (
    'rgb' +
    (hasAlpha ? 'a(' : '(') +
    round(
      (absPerc * toInt(rMin[3] == 'a' ? rMin.slice(5) : rMin.slice(4)) ** 2 +
        perc * toInt(rMax[3] == 'a' ? rMax.slice(5) : rMax.slice(4)) ** 2) **
        0.5,
    ) +
    ',' +
    round((absPerc * toInt(gMin) ** 2 + perc * toInt(gMax) ** 2) ** 0.5) +
    ',' +
    round((absPerc * toInt(bMin) ** 2 + perc * toInt(bMax) ** 2) ** 0.5) +
    alpha
  )
}
